import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Badge } from '../../../../../../components/SearchForm/components/ViewSwitch/components/Badge/index.js';
import { Container } from '../../../../../../components/SearchForm/components/ViewSwitch/components/CustomOption/components/Container.js';
import { Stack } from '../../../../../../primitives/index.js';
import { SPACING_SMALL } from '../../../../../../utils/spacingLegacy.js';
export const CustomOption = props => {
  const {
    data,
    innerRef,
    innerProps
  } = props;
  return _jsx(Container, {
    ref: innerRef,
    ...innerProps,
    children: _jsxs(Stack, {
      direction: "row",
      spacing: SPACING_SMALL,
      alignItems: "center",
      children: [data.label, data.hasBadge && _jsx(Badge, {})]
    })
  });
};